export enum InvoicingCutoffEnums {
  estadoAbierto = 1,
  estadoPrefacturado = 2,
  estadoFacturado = 3,
  estadoSuspendido = 4,

  tipoCompleto = 1,
  tipoMovimiento = 2,
  tipoServicio = 3
}